import servicio from "./axiosServices";

export function obtenerCursos() {
  return servicio.get("Curso/");
}

export function obtenerCursoDetalle(idUdemy) {
  return servicio.get("Curso/" + idUdemy);
}
